module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/top_service_three-69f82b8d6cb9173a9a7e4cc7dbac6887.png";